module.exports = __webpack_public_path__ + "static/media/Transfers.0576af5a.svg";